import React from 'react';
import { TextArea } from '@pwc/pwc-deals-ui';
import { useAutoResize } from '../structured-analysis/common/hooks/useAutoResize';

const NotesInput = ({ field }) => {
  useAutoResize(field.value, 'notes');

  return (
    <div data-testid="notes-input-container">
      <TextArea
        name="notes"
        field={field}
        label="Footnotes (optional)"
        placeholder="Add notes"
        maxLength={250}
        showEditIcon
        labelIcon="note"
        includeSeparator
        basic
      />
    </div>
  );
};

export default NotesInput;
